/**
 * The exact server capability keys this feature gates on (sampling + sampling-queue-core routers).
 * Every mutating action is gated client-side via useCan(...) — the server re-checks every request.
 */
export const CAP = {
  /** Read the waiting-room board, the rooms list, the bench files. */
  fileRead: "sampling.file.read",
  /** Resolve a scanned tube (POST /sampling/scan). */
  prelevementRead: "sampling.prelevement.read",
  /** Call / absent / acheminer / terminer / appeler-suivant (the queue lifecycle). */
  prelevementUpdate: "sampling.prelevement.update",
  /** Record a draw / redraw / enqueue a tube to a bench (the append-only writes). */
  prelevementCreate: "sampling.prelevement.create",
  /** Print the matricule vignette (R-10). */
  matriculePrint: "sampling.matricule.print",
} as const;
